// @flow

import {
  SequenceDiagramActionNode,
  SequenceDiagramActorNode,
} from './SequenceDiagram';
import {StateDiagramNode} from './StateDiagram/StateDiagramNode';
import {OverviewDiagramIconNode} from './OverviewDiagram/OverviewDiagramIconNode';
import {OverviewDiagramTextNode} from './OverviewDiagram/OverviewDiagramTextNode';
import {EntityDiagramNode} from './EntityDiagram/EntityDiagramNode';

export const nodeTypes = {
  sequenceActor: SequenceDiagramActorNode,
  sequenceAction: SequenceDiagramActionNode,
  state: StateDiagramNode,
  icon: OverviewDiagramIconNode,
  text: OverviewDiagramTextNode,
  entity: EntityDiagramNode,
};
